import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class ClientsService {
  header = new HttpHeaders();
  private adminAPI = (location.hostname != 'localhost') ? 'https://us-central1-admin-infondo.cloudfunctions.net/app' : 'http://localhost:5001/admin-infondo/us-central1/app'
  constructor(private httpClient: HttpClient) {
    this.header.append('Content-Type','application/json; charset=utf-8');
  }

  public createClient(client){
    return this.httpClient.post(`${this.adminAPI}/clientes`, client, {headers: this.header}).toPromise()
  }
}
